import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getTagImageUrl } from '../utils/imageUtils';

const TagCard = ({ tag, onClick }) => {
    // Replace spaces with hyphens or underscores
    const imageName = tag.name.replace(/\s+/g, '-'); // or use '_' instead of '-'
    const tagImageUrl = getTagImageUrl(imageName);

    useEffect(() => {
        console.log('TagCard component rendered with tag:', JSON.stringify(tag));
        // console.log('looking for image:', `/images/dietImages/${imageName}.jpg`);
        // console.log('diet object:', JSON.stringify(diet));
    }, []);

    // If onClick is provided, use it instead of Link
    if (onClick) {
        return (
            <div 
                onClick={() => onClick(tag)}
                className="tag-card"
                style={{ cursor: 'pointer' }}
            >
                <img
                    className="tag-card-image"
                    src={tagImageUrl}
                    alt={tag.name}
                />
                <div className="tag-card-content">
                    <h3 className="tag-filter-name">{tag.name}</h3>
                </div>
            </div>
        );
    }

    return (
        <Link to={`/tag/${tag.name}`} state={{ tag: tag}} className="tag-card">
            <img
                className="tag-card-image"
                src={tagImageUrl}
                alt={tag.name}
            />
            <div className="tag-card-content">
                <h3 className="tag-filter-name">{tag.name}</h3>
            </div>
        </Link>
    );

}

export default TagCard;